import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    percepciones: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_PERCEPCIONES' (state, jurisdicciones) {
        state.percepciones = [];

        // for (let index = 0; index < jurisdicciones.length; index += 2) {

        //     let percepcionJurisdiccion1 = {
        //         jurisdiccionIngresosBrutosId: jurisdicciones[index].id,
        //         jurisdiccion: jurisdicciones[index].nombre,
        //         state: null,
        //         msjInvalido: '',
        //         importe: 0,
        //     }
        //     let percepcionJurisdiccion2 = {
        //         jurisdiccionIngresosBrutosId: jurisdicciones[index + 1].id,
        //         jurisdiccion: jurisdicciones[index + 1].nombre,
        //         state: null,
        //         msjInvalido: '',
        //         importe: 0,
        //     }

        //     state.percepciones.push({
        //         id: index,
        //         percepcionJurisdiccion1,
        //         percepcionJurisdiccion2,
        //     });
        // }

        jurisdicciones.forEach(jurisdiccion => {
            state.percepciones.push({
                jurisdiccionIngresosBrutosId: jurisdiccion.id,
                jurisdiccion: jurisdiccion.nombre,
                state: null,
                msjInvalido: '',
                importe: 0,
            });
            
        });
    },

    'SET_PERCEPCIONES' (state, percepciones) {
        state.percepciones = [];
        percepciones.forEach(percepcion => {
            state.percepciones.push({
                jurisdiccionIngresosBrutosId: percepcion.jurisdiccionId,
                jurisdiccion: percepcion.jurisdiccion,
                state: null,
                msjInvalido: '',
                importe: percepcion.importe,
            })
        });
    },
    'AGREGAR_JURISDICCION' (state, jurisdiccion) {
        let itemKey = state.percepciones
            .findIndex(percepcion => percepcion.jurisdiccionIngresosBrutosId == jurisdiccion.id);

        if (itemKey == -1) {
            state.percepciones.push({
                jurisdiccionIngresosBrutosId: jurisdiccion.id,
                jurisdiccion: jurisdiccion.nombre,
                state: null,
                msjInvalido: '',
                importe: 0,
            })
        }
    },
};

const getters = {
    getField,

    percepciones(state) {
        return state.percepciones;

        // let percepciones = [];
        // state.percepciones.forEach(percepcionesGrupo => {
        //     percepciones.push(percepcionesGrupo.percepcionJurisdiccion1);
        //     percepciones.push(percepcionesGrupo.percepcionJurisdiccion2);
        // });

        // return percepciones;
    },
};

const actions = {
    inicializar ( { commit }, percepciones ) {
        return new Promise((resolve, reject) => {
            let inicializar = true;

            if (percepciones) {
                if (percepciones.length != 0) {
                    inicializar = false;
                    
                    commit('SET_PERCEPCIONES', percepciones);
                    resolve();
                }
            }

            if (inicializar) {
                apiAxios.get('jurisdiccionesingresosbrutos')
                    .then((res) => {
                        commit("INICIALIZAR_PERCEPCIONES", res.data);
                        resolve();
                    })
                    .catch (error => {
                        reject(error);
                    })
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })            
    },
    save ( {} ) {
        return new Promise((resolve, reject) => {
            resolve();
        }, error => {
            reject(error);
        })
    },
    agregarJurisdiccion ( { commit }, jurisdiccion ) {
        return new Promise((resolve, reject) => {
            commit('AGREGAR_JURISDICCION', jurisdiccion);
            resolve();
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}